import { memo } from "react";

import type { InputMaybe } from "@/lib/gql/__generated__/graphql";

import { FeatureIslandCategoryQuestionForMain } from "@/components/features/_layouts/island/main-with-category/components/category-main-question";
import type { ForNodeType } from "@/components/features/_model/types/auto-generator-for-view-model";

import type { FormOptionType } from "@/components/ui/form/_types/type";
import { SelectField } from "@/components/ui/form/fields/select-field";

type Props = {
	defaultDiscountID: ForNodeType<InputMaybe<string> | undefined> | undefined;
	onSetDefaultDiscountID: (input: string) => void;
	discountNameAndIDOptions: FormOptionType[];
};

export const QuestionPlanDefaultDiscount = memo(
	({ defaultDiscountID, onSetDefaultDiscountID, discountNameAndIDOptions }: Props) => {
		const title = "自動で適用されるディスカウント";

		return (
			<FeatureIslandCategoryQuestionForMain
				required={false}
				title={title}
				isEdited={defaultDiscountID?.isEdited}
				hasError={Boolean(defaultDiscountID?.error)}
				inputChildren={
					<SelectField
						value={defaultDiscountID?.value || "null"}
						options={discountNameAndIDOptions}
						handleValueChange={onSetDefaultDiscountID}
					/>
				}
			/>
		);
	},
);

QuestionPlanDefaultDiscount.displayName = "QuestionPlanDefaultDiscount";
